/**
 * HR help text for the Expense module.
 *
 * An approved expense claim is reimbursed through payroll. A claim that is not
 * linked to another request is paid on its own; a claim linked to a travel
 * request is settled through that travel request instead, so it is deliberately
 * skipped by the standalone expense payitem.
 */

const expenseRequest = {
  employment_id: "Employee claiming the expense. Their approval workflow decides who receives the claim.",
  name: "Short name for this claim so approvers can recognize it in their list.",
  description: "What the expense was for. Approvers read this before approving.",
  extension_no: "Office extension where the employee can be reached about this claim.",
  is_linked_request: "Tick this when the expense belongs to a travel request. A linked claim is settled through that travel request rather than being reimbursed separately, so linking the wrong claim can leave it unpaid.",
  linked_request_type: "Which kind of request this claim belongs to.",
  linked_request_id: "The specific request this claim is attached to. The claim is settled together with it.",
  paymentmethod_id: "How the reimbursement is paid, such as bank transfer or cash.",
  approved_amount: "Amount actually approved for payment. The approver can reduce it below what was claimed, and payroll reimburses only this figure.",
  processed: "Marks the claim as already paid. Processed claims are skipped by the payroll run, so leave it off for claims still waiting to be reimbursed.",
  is_active: "Only active claims move through the approval workflow.",
  last_remarks: "Remarks written by the last approver. Visible in the claim history.",
  reasons: "Reasons recorded at each step of the approval so far.",
  currency_id: "Currency the expense was incurred in.",
  expense_type_id: "Category of expense, such as fuel or meals. It decides which limits and reports the claim falls under.",
  amount: "Amount being claimed for this line.",
  attachment: "Receipt or bill for this expense. Approvers open it to check the claim.",
  date: "Date the expense was incurred.",
};

const expenseType = {
  name: "Name of this expense category, such as Fuel or Meals. Employees pick it on each claim line, and reports group spending by it.",
  description: "Internal note explaining what belongs under this category.",
  is_active: "Only active types can be selected on a new claim. Existing claims keep the type they were raised with.",
};

export const expenseTooltips = { expenseRequest, expenseType };
export default expenseTooltips;
